import createAxiosInstance from '../createAxiosInstance';

const USER_API_URL = import.meta.env.VITE_API_URL_USER;

if (USER_API_URL === undefined) {
    throw new Error('User API URL is not defined');
}

const axios = createAxiosInstance(USER_API_URL);

export default axios;
